export default [
  {
    value: 'Capital - Santiago del Estero'
  },
  {
    value: 'Aguirre - Argentina'
  },
  {
    value: 'Aguirre - Casares'
  },
  {
    value: 'Aguirre - Colonia Hermelina'
  },
  {
    value: 'Aguirre - El Aibal'
  },
  {
    value: 'Aguirre - El oso'
  },
  {
    value: 'Aguirre - El palmar'
  },
  {
    value: 'Aguirre - El tropezon'
  },
  {
    value: 'Aguirre - Las Promesas'
  },
  {
    value: 'Aguirre - Malbran'
  },
  {
    value: 'Aguirre - Tres Pozos'
  },
  {
    value: 'Aguirre - Tronco Blanco'
  },
  {
    value: 'Aguirre - Villa General Mitre'
  },
  {
    value: 'Alberdi - Agustina Libarona'
  },
  {
    value: 'Alberdi - Ahi veremos'
  },
  {
    value: 'Alberdi - Anca Overa'
  },
  {
    value: 'Alberdi - Campo Alegre'
  },
  {
    value: 'Alberdi - Campo Gallo'
  },
  {
    value: 'Alberdi - Campo verde'
  },
  {
    value: 'Alberdi - Chañarito'
  },
  {
    value: 'Alberdi - Cuatro Esquinas'
  },
  {
    value: 'Alberdi - El bajo'
  },
  {
    value: 'Alberdi - El Corrido'
  },
  {
    value: 'Alberdi - El Majan'
  },
  {
    value: 'Alberdi - El Milagro'
  },
  {
    value: 'Alberdi - El Porvenir'
  },
  {
    value: 'Alberdi - El Remanso'
  },
  {
    value: 'Alberdi - El simbol'
  },
  {
    value: 'Alberdi - Esteco'
  },
  {
    value: 'Alberdi - Huachana'
  },
  {
    value: 'Alberdi - Ingrata Norte'
  },
  {
    value: 'Alberdi - Ingrata Sur'
  },
  {
    value: 'Alberdi - La Paloma'
  },
  {
    value: 'Alberdi - San Isidro'
  },
  {
    value: 'Alberdi - San Jose'
  },
  {
    value: 'Alberdi - San Luis'
  },
  {
    value: 'Alberdi - Santos Lugares'
  },
  {
    value: 'Alberdi - Sol de Mayo'
  },
  {
    value: 'Alberdi - Taco Pozo'
  },
  {
    value: 'Alberdi - Vinal Viejo'
  },
  {
    value: 'Atamisqui - Ancocha'
  },
  {
    value: 'Atamisqui - Brea Loma'
  },
  {
    value: 'Atamisqui - Chilca la Loma'
  },
  {
    value: 'Atamisqui - Codo viejo'
  },
  {
    value: 'Atamisqui - Collera huarcana'
  },
  {
    value: 'Atamisqui - El dorado'
  },
  {
    value: 'Atamisqui - El hoyon'
  },
  {
    value: 'Atamisqui - El peral'
  },
  {
    value: 'Atamisqui - El peru'
  },
  {
    value: 'Atamisqui - Estacion Atamisqui'
  },
  {
    value: 'Atamisqui - Guanaco Sombriana'
  },
  {
    value: 'Atamisqui - Juanillo'
  },
  {
    value: 'Atamisqui - Medellin'
  },
  {
    value: 'Atamisqui - Simbol Pozo'
  },
  {
    value: 'Atamisqui - Sonconcho'
  },
  {
    value: 'Atamisqui - Tasigasta'
  },
  {
    value: 'Atamisqui - Ventura Pampa'
  },
  {
    value: 'Atamisqui - Villa Atamisqui'
  },
  {
    value: 'Avellaneda - Blanca Pozo'
  },
  {
    value: 'Avellaneda - Caloj'
  },
  {
    value: 'Avellaneda - Campo Alegre'
  },
  {
    value: 'Avellaneda - Colonia Alcira'
  },
  {
    value: 'Avellaneda - Colonia Dora'
  },
  {
    value: 'Avellaneda - Colonia Libanesa'
  },
  {
    value: 'Avellaneda - Gramilla'
  },
  {
    value: 'Avellaneda - Herrera'
  },
  {
    value: 'Avellaneda - Icaño'
  },
  {
    value: 'Avellaneda - La Costa'
  },
  {
    value: 'Avellaneda - Lugones'
  },
  {
    value: 'Avellaneda - Lujan'
  },
  {
    value: 'Avellaneda - Palermo'
  },
  {
    value: 'Avellaneda - Paso Grande'
  },
  {
    value: 'Avellaneda - Percas'
  },
  {
    value: 'Avellaneda - Pozo Mosoj'
  },
  {
    value: 'Banda - Abra Grande'
  },
  {
    value: 'Banda - Ahi Veremos'
  },
  {
    value: 'Banda - Alto Pozo'
  },
  {
    value: 'Banda - Ardiles'
  },
  {
    value: 'Banda - Bajo Grande'
  },
  {
    value: 'Banda - Bajo Hondo'
  },
  {
    value: 'Banda - Bayo Muerto'
  },
  {
    value: 'Banda - Cañada Escobar'
  },
  {
    value: 'Banda - Cerrillos'
  },
  {
    value: 'Banda - Chaupi Pozo'
  },
  {
    value: 'Banda - Clodomira'
  },
  {
    value: 'Banda - El Alambrado'
  },
  {
    value: 'Banda - El Barrial'
  },
  {
    value: 'Banda - El Carmen'
  },
  {
    value: 'Banda - El Ojo de Agua'
  },
  {
    value: 'Banda - Guaycuru'
  },
  {
    value: 'Banda - Huyamampa'
  },
  {
    value: 'Banda - Isla Corral'
  },
  {
    value: 'Banda - Jumi Pozo'
  },
  {
    value: 'Banda - Jumialito'
  },
  {
    value: 'Banda - La Bajada'
  },
  {
    value: 'Banda - La Banda'
  },
  {
    value: 'Banda - La Darsena'
  },
  {
    value: 'Banda - La Falda'
  },
  {
    value: 'Banda - La Granja'
  },
  {
    value: 'Banda - Los Soria'
  },
  {
    value: 'Banda - Mistolito'
  },
  {
    value: 'Banda - Monte Bello'
  },
  {
    value: 'Banda - Negra Muerta'
  },
  {
    value: 'Banda - Nueva Lujan'
  },
  {
    value: 'Banda - Rubia Moreno'
  },
  {
    value: 'Banda - San Carlos'
  },
  {
    value: 'Banda - San Jose'
  },
  {
    value: 'Banda - Simbolar'
  },
  {
    value: 'Banda - Tabla Redonda'
  },
  {
    value: 'Banda - Tramo 16'
  },
  {
    value: 'Banda - Vaca Muerta'
  },
  {
    value: 'Belgrano'
  },
  {
    value: 'Capital - Abra Grande'
  },
  {
    value: 'Capital - Antilo'
  },
  {
    value: 'Capital - Churqui'
  },
  {
    value: 'Capital - Dolores'
  },
  {
    value: 'Capital - El Barrial'
  },
  {
    value: 'Capital - El Dean'
  },
  {
    value: 'Capital - El Mojon'
  },
  {
    value: 'Capital - El Puestito'
  },
  {
    value: 'Capital - El Zanjon'
  },
  {
    value: 'Capital - Estacion Ing Escurra'
  },
  {
    value: 'Capital - Huaico Hondo'
  },
  {
    value: 'Capital - La Candelaria'
  },
  {
    value: 'Capital - La Estancita'
  },
  {
    value: 'Capital - La Mesada'
  },
  {
    value: 'Capital - La Puerta'
  },
  {
    value: 'Capital - Loma Grande'
  },
  {
    value: 'Capital - Lomas de Zamora'
  },
  {
    value: 'Capital - Los Cardozos'
  },
  {
    value: 'Capital - Los Positos'
  },
  {
    value: 'Capital - Maco'
  },
  {
    value: 'Capital - Mal Paso'
  },
  {
    value: 'Capital - Maquito'
  },
  {
    value: 'Capital - Palomar'
  },
  {
    value: 'Capital - Pampa Muyoj'
  },
  {
    value: 'Capital - Pozo Cavado'
  },
  {
    value: 'Capital - Puesto de San Antonio'
  },
  {
    value: 'Capital - Puesto del Medio'
  },
  {
    value: 'Capital - Remes'
  },
  {
    value: 'Capital - Rodeo de Soria'
  },
  {
    value: 'Capital - San Antonio de los Caceres'
  },
  {
    value: 'Capital - San Benito'
  },
  {
    value: 'Capital - San Cristobal'
  },
  {
    value: 'Capital - San Jose'
  },
  {
    value: 'Capital - San Lorenzo'
  },
  {
    value: 'Capital - San Lorenzo de los Sayagos'
  },
  {
    value: 'Capital - San Pedro'
  },
  {
    value: 'Capital - Santa Maria'
  },
  {
    value: 'Capital - Santa Rosa'
  },
  {
    value: 'Capital - Santo Domingo'
  },
  {
    value: 'Capital - Sol de Mayo'
  },
  {
    value: 'Capital - Tipiro'
  },
  {
    value: 'Capital - Tunas Punco'
  },
  {
    value: 'Capital - Upianita'
  },
  {
    value: 'Capital - Vuelta de la Barranca'
  },
  {
    value: 'Capital - Yanda'
  },
  {
    value: 'Choya'
  },
  {
    value: 'Figueroa'
  },
  {
    value: 'General Taboada'
  },
  {
    value: 'Guasayán'
  },
  {
    value: 'Jiménez'
  },
  {
    value: 'Juan Felipe Ibarra'
  },
  {
    value: 'Loreto'
  },
  {
    value: 'Mitre'
  },
  {
    value: 'Moreno'
  },
  {
    value: 'Ojo de Agua'
  },
  {
    value: 'Pellegrini'
  },
  {
    value: 'Quebrachos'
  },
  {
    value: 'Rivadavia'
  },
  {
    value: 'Robles'
  },
  {
    value: 'Rio Hondo'
  },
  {
    value: 'Salavina'
  },
  {
    value: 'San Martin'
  }
];
